import { faRupeeSign, faEuroSign, faPoundSign, faDollarSign } from '@fortawesome/free-solid-svg-icons';

const Regions = [
    { ID: 1, Name: "India", Code: "IN", Currency: "INR", TaxSystem: "GST", Symbol: faRupeeSign },
    { ID: 1, Name: "USA", Code: "US", Currency: "Dollar", TaxSystem: "VAT", Symbol: faDollarSign },
    { ID: 2, Name: "UAE", Code: "AE", Currency: "AED", TaxSystem: "VAT", Symbol: null },
    { ID: 3, Name: "United Kingdom", Code: "GB", Currency: "Pound", TaxSystem: "VAT", Symbol: faPoundSign },
    { ID: 4, Name: "Germany", Code: "DE", Currency: "Euro", TaxSystem: "VAT", Symbol: faEuroSign }
];


export default Regions;